var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationLightbulb = function SvgSimpleIllustrationLightbulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "simple-illustration__lightbulb_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 68 68",
    style: {
      enableBackground: "new 0 0 68 68"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".simple-illustration__lightbulb_svg__st2,.simple-illustration__lightbulb_svg__st3{fill:none;stroke:#002140;stroke-width:1;stroke-linecap:round;stroke-linejoin:round}.simple-illustration__lightbulb_svg__st3{stroke:#fed607}")), /*#__PURE__*/React.createElement("path", {
    d: "M29.419 48.482s.995 1.566 5.269 1.424c4.269-.142 5.981-1.424 5.981-1.424s2.137-4.556 3.132-6.689c.995-2.137 3.703-7.401 3.132-11.246-.571-3.844-5.41-9.68-13.241-9.68-7.83 0-10.675 8.826-10.675 11.675s2.137 8.543 2.137 8.543l4.269 7.401-.004-.004z",
    style: {
      fill: "#ffed8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.665 48.482s-2.231 1.236-4.981 1.137c-2.75-.094-6.453-.571-6.453-.571l1.995 4.557s-.094 1.613-.094 1.896c0 .283 1.137 2.467 3.415 2.467s4.368-1.896 4.368-2.184c0-.288-.377-2.184-.377-2.184s1.995-3.703 2.137-5.123l-.01.005z",
    style: {
      fill: "#ccf6ff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.718 32.796c0 7.011 5.621 11.117 6.406 16.416M46.963 32.916c0 6.565-5.659 10.452-6.234 15.236M46.955 32.796c0-6.693-5.428-12.121-12.121-12.121s-12.121 5.11-12.121 12.121",
    className: "simple-illustration__lightbulb_svg__st2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.746 48.006c-.472 3.801-2.943 6.706-5.925 6.706-2.982 0-5.325-2.75-5.882-6.402",
    className: "simple-illustration__lightbulb_svg__st2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.938 48.306s5.565 2.961 11.791-.154M38.45 53.373c.322.45.506.965.506 1.515 0 1.733-1.836 3.141-4.097 3.141s-4.097-1.407-4.097-3.141c0-.433.116-.845.322-1.223",
    className: "simple-illustration__lightbulb_svg__st2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.473 49.152a5.565 5.565 0 0 0-.227-4.316c-.365-.747-1.03-1.472-1.862-1.45a1.257 1.257 0 0 0-1.008.532c-.223.33-.245.785-.039 1.116.245.395.764.558 1.223.489.459-.069.867-.335 1.218-.639.455-.39.854-.867 1.098-1.416.232-.519.33-1.09.352-1.656.026-.648-.047-1.313-.317-1.905-.27-.592-.755-1.103-1.369-1.313",
    className: "simple-illustration__lightbulb_svg__st2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.467 26.798h6.264M49.765 26.798h6.264M34.246 16.976V10M24.283 19.68l-5.342-5.338M43.856 18.684l5.338-5.337",
    className: "simple-illustration__lightbulb_svg__st3"
  })));
};
export default SvgSimpleIllustrationLightbulb;